var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"graph",staticClass:"div",style:(_vm.cssVars)},[_c('span',{ref:"span",staticClass:"span"},[_vm._v(_vm._s(_vm.valor)+"%")]),_c('canvas',{ref:"canvas",staticClass:"canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }